import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowRight } from 'lucide-react';

const NotFound = () => (
  <div className="container-app py-24 text-center" data-testid="not-found-page">
    <div className="font-display text-7xl font-bold gradient-text">404</div>
    <h1 className="mt-4 font-display text-2xl font-bold">Page not found</h1>
    <p className="mt-2 text-muted-foreground">The page you're looking for doesn't exist or has been moved.</p>
    <div className="mt-6 flex flex-wrap gap-3 justify-center">
      <Button asChild className="bg-gradient-primary text-primary-foreground">
        <Link to="/"><Home className="mr-2 h-4 w-4" /> Back to home</Link>
      </Button>
      <Button asChild variant="outline">
        <Link to="/e-services">Browse services <ArrowRight className="ml-2 h-4 w-4" /></Link>
      </Button>
    </div>
  </div>
);

export default NotFound;
